module.exports = __webpack_public_path__ + "media/src/images/icons/verified-e072e5ac9e79d084d12388fb0b876c37.svg";